import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectSiteById,
  selectSitesBySn,
  selectSitesState,
  viewSiteSn,
  deleteSite,
  leaveSiteContactship,
  fetchSitesBySn,
  selectSiteBySiteId,
  selectSitesStateBySn,
  fetchSites,
  selectSitesBySiteSn,
  selectSiteBySn,
} from '../../redux/slices/sitesSlice';
import { autoLogin, selectAuthState, setUser } from '../../redux/slices/authSlice';
import { fetchContacts, selectContactsBySiteId, selectContactsState, updateContact } from '../../redux/slices/contactsSlice';
import { fetchUsers } from '../../redux/slices/usersSlice';
import { RootState } from '../../redux/store';
import SiteForm from './SiteForm';
import ContactsCard from './ContactsCard';
import ConcentrateursCard from './ConcentrateursCard';
import ConfirmDialog from '../../components/ConfirmDialog';
import FormDialog from '../../components/FormDialog';
import { formatDateTime } from '../../utils/helperFuncs';
import SubjectIcon from '@material-ui/icons/Subject';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  fetchConcentrateursBySiteId,
  fetchConcentrateursBySitesSn,
  selectConcentrateursBySiteId,
  selectConcentrateursBySiteSn,
  selectConcentrateurById,
  selectConcentrateursState,
  fetchAllConcentrateurs,
  fetchConcentrateursForSiteSn,
} from '../../redux/slices/concentrateursSlice';

import {
  Paper,
  Typography,
  Button,
  Divider,
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  InputAdornment,
  TableHead,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useMainPageStyles, useTableStyles } from '../../styles/muiStyles';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import PeopleAltTwoToneIcon from '@material-ui/icons/PeopleAltTwoTone';
import { Contact, ContactPayload, ContactState, SitePayload, SiteState } from '../../redux/types';
import { useForm } from 'react-hook-form';
import { Label, TextFieldsOutlined, Title } from '@material-ui/icons';
import { number, string } from 'yup';
import { keys } from '@material-ui/core/styles/createBreakpoints';
import SitesActionCard from './SitesActionCard';
import SiteDetailForm from './SiteDetailForm';
import SiteDetailFormx from './SiteDetailFormx';
import { useReducer } from 'react';
import authService from '../../services/auth';
import storage from '../../utils/localStorage';
import { fetchEquipementsBySiteId, fetchEquipementsForSiteSn, selectEquipementsState } from '../../redux/slices/equipementsSlice';
import SiteCreation from './SiteCreation';

const validationSchema = yup.object({
  title: yup
    .string()
    .required('Required')
    .min(3, 'Must be at least 3 characters')
    .max(60, 'Must be at most 60 characters'),
  description: yup.string().required('Required'),
});

interface ParamTypes {
/*  
  contactId: string; */
  siteId: string;
  siteSn: string; /*
  sitesWSn: string;    // contient les sites correspondants au SN demandé SiteState[]
  contactsSitesSn: string;*/ //ContactState[];
/*concHardSn: string;
  concTel: string;
  concId: string;
  isMobile: boolean;*/
  /*siteSn: string;
  concentrateurs: string;*/
//  concentrateurs: Array<{ id: string }>;
}
/*
type occupationProps = {
  siteId: string;
  range: string;
  nombre: number;
  taux: number;
}
type statsOccup = {
  [key:string]: occupationProps[];
}*/
/*type statsOccupy = {
  /*[key:string]: /occupationProps;
//  occupationProps{};
}*/
//interface statsOccupy { [index: string]: { nombre: number, taux: number }}

const SiteDetailsPage = () => {
  const classes = useMainPageStyles();
  const classes2 = useTableStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();
  const dispatch = useDispatch();
  const { siteId, siteSn } = useParams<ParamTypes>();
  const { sites, fetchStatus, filterBy } = useSelector(
    selectSitesState
  );
  console.log("SITES length: "+sites.length)
  console.log("SiteId & siteSn: "+siteId+" / "+siteSn)
  const siteInState = sites.filter((s) => Number(s.sn_site) === Number(siteSn))
/*  const siteInState = useSelector((state: RootState) =>
    selectSitesBySn(state, siteSn) // retourne tous les sites et non ceux correspondant au siteSn //.filter((s)=>s.sn_site===siteSn)
  );*/
/*  const siteInState = useSelector((state: RootState) =>
    selectSiteById(state, siteId)
  );*/
  //currentData = siteInState
  const { equipements, fetchLoading, fetchError, sortBy } = useSelector(
    selectEquipementsState
  );

  useEffect(() => {
    dispatch(autoLogin());
    if( !sites ) {
      dispatch(fetchSitesBySn(siteSn))
    }
    if(siteId !== "" && siteSn !== "") {
      dispatch(fetchEquipementsForSiteSn(siteSn));    // CAUSE jwt malformed error ?
      dispatch(fetchConcentrateursForSiteSn(siteSn));    // CAUSE jwt malformed error ?
    }
    if(!equipements) {
      dispatch(fetchEquipementsBySiteId(siteId))
    }
  }, []);
  //dispatch(fetchEquipementsBySiteId(siteId))
  /*  useEffect(() => {
    if(currentData?.sn_site) {
      fetchEquipementsBySitesSn(currentData.sn_site)
    }
  }, [equipements]);*/
  
  console.log("t'as des sites ?? => "+siteInState?.length+" pour ce SN: "+siteSn)
  const [selectedSite, setSelectedSite] = useState(siteInState?.find((s) => Number(s.id) === Number(siteId)))
  //if(!(siteInState.length > 0)) {
  if(siteId === "" && siteSn === "") {
    return (
      <div className={classes.root}>
        <Paper className={classes.notFoundPaper}>
          <Typography
            variant="h6"
            color="secondary"
            className={classes.error404Text}
            style={{ marginTop: '5em' }}
          >
            404: Logement non trouvé !??
          </Typography>
        </Paper>
      </div>
    );
  }
  if(siteInState.length > 0) {
    console.log("SN site in sitesInState: "+siteInState.find((s) => Number(s.id) === Number(siteId))?.sn_site)
/*    const {id, sn_site, contacts, date_instru, date_end, date_update, concentrateur, gmt_date, tx_occupation, type_inst_elec,
      index_cpt_elec, index_cpt_hc, tarif_elec, puiss_sscrite, prm_linky, adresse, code_postal, instrum_by, nature, surface, surf_unused,
      surf_nonchauff, niveaux, rq_instru, chauff_nrj, chauff_detail, chauff_rq, ecs_nrj, ecs_detail, ecs_rq, ventil_type, ventil_detail,
      ventil_rq, clim_type, clim_detail, clim_rq, piscine_infos, cuissonplq_nrj, cuissonplq_detail, cuissonplq_rq, four_type, four_detail,
      four_rq, veilles_app, veilles_pw, veilles_rq, cpt_type } = siteInState.find((s) => Number(s.id) === Number(siteId)) || siteInState[0];*/
  
    const isAdmin = true;
    const handleChangeSite = (event: React.ChangeEvent<{ name?: string | undefined; value: unknown; }> /*event: SelectChangeEvent*/) => {
      const value = Number(event.target.value);
      console.log("EVENTsiteChange ############################################# : "+event.target.name+" => "+event.target.value);
      setSelectedSite(siteInState.find((s) => Number(s.id) === value) || siteInState.find((s) => Number(s.id) === Number(siteId)))
    };
    const setLogementsList = () => {
      if(selectedSite !== undefined) {
        return (
          <>
          <InputLabel shrink /*className={classes.flexInput}*/>Date d'état sélectionnée</InputLabel>
          <Select /*inputRef={register}*/ /*displayEmpty defaultValue={currSite_id}*/
            label="Date update" onChange={handleChangeSite} //id="site_id"
            margin="dense" variant="outlined" className={classes.flexInput} value={selectedSite?.id !== undefined ? selectedSite.id : null}
              /*|| siteInState.find((s,index) => index === siteInState.length ? s.id : null)*//*state.site_id*/
              /*defaultValue={siteInState.find((s) => Number(s.id) === Number(siteId))?.id}*/ name="theSite">
            {siteInState.map((u) => (( u.id !== selectedSite.id )) ?
              <MenuItem key={u.id+"_update"} value={u.id}>Vue du {u.date_update} [{u.id}]</MenuItem> 
              : <MenuItem key={u.id+"_update"} value={u.id} selected><em>Vue du {u.date_update} [{u.id}]</em></MenuItem>
              /*sitesBySn.map((u) => ( <MenuItem key={u.id} value={u.id}>{u.date_update}</MenuItem> */
              /*Number(u) !== Number(currSite_id/*state.site_id/) ? <MenuItem key={u} value={u}>{sitesBySn?.find((s) => Number(s.id) === Number(u))?.date_update}</MenuItem> 
              : <MenuItem key={u} value={u} selected><em>{sitesBySn?.find((s) => Number(selectedSiteid) === Number(u))?.date_update}</em></MenuItem>*/
            )}
          </Select>
            { selectedSite !== undefined ?
            <div id={"div"+selectedSite.id} /*style={{'display': (Number(selectedSite.id) !== Number(selectedSite) ? 'none' : 'block' ) }}*/>
              <div className={classes.btnsWrapper}>
                <SiteDetailFormx key={"k"+selectedSite.id} siteId={selectedSite.id} currentData={selectedSite}
                  isEditMode={true} isMobile={false} equipements={equipements}/>
                  {/*<SiteDetailForm currSite={state.theSite} currContact={contactDuSite} sites={sitesBySn} theId={currSite_id} />*/}
                  {/*<SiteDetailForm currSite={sitesBySn.find((s)=>Number(s.id) === Number(currSite_id))} sites={sitesBySn} theId={currSite_id} currContact={contactDuSite} />*/}
              </div>
            </div>
            : null }
          </>
        ) } else { return (
          <Select /*inputRef={register}*/ /*displayEmpty defaultValue={currSite_id}*/
            label="Date update" onChange={handleChangeSite} //id="site_id"
            margin="dense" variant="outlined" className={classes.flexInput} value={/*selectedSite?.id !== undefined ? selectedSite.id :*/ null}
              /*|| siteInState.find((s,index) => index === siteInState.length ? s.id : null)*//*state.site_id*/
              /*defaultValue={siteInState.find((s) => Number(s.id) === Number(siteId))?.id}*/ name="theSite">
            {siteInState.map((u) => 
              <MenuItem key={u.id+"_update"} value={u.id}>Vue du {u.date_update} [{u.id}]</MenuItem> 
              /*sitesBySn.map((u) => ( <MenuItem key={u.id} value={u.id}>{u.date_update}</MenuItem> */
              /*Number(u) !== Number(currSite_id/*state.site_id/) ? <MenuItem key={u} value={u}>{sitesBySn?.find((s) => Number(s.id) === Number(u))?.date_update}</MenuItem> 
              : <MenuItem key={u} value={u} selected><em>{sitesBySn?.find((s) => Number(selectedSiteid) === Number(u))?.date_update}</em></MenuItem>*/
            )}
          </Select>) }
    };
  
    return (
      <Paper className={classes.detailsHeader}>
        <div><Typography
          variant={isMobile ? 'h5' : 'h4'}
          color="secondary"
          style={{ marginRight: '0.2em' }}
        >
          <strong>Logement {siteSn}</strong>
        </Typography>
        <p>Sélectionnez ci-dessous une date d'état du logement pour mettre à jour les infos.<br/>
        Vous pouvez valider les changement en créant une nouvelle date "d'état", ou écraser les infos d'une date "d'état" existante.</p>
        </div>
        <Divider style={{ margin: '0.5em 0' }} />
        {setLogementsList()}
      </Paper>
    );
  } else {
    return (
      <div className={classes.root}>
        <Paper className={classes.notFoundPaper}>
          <Typography
            variant="h6"
            color="secondary"
            className={classes.error404Text}
            style={{ marginTop: '5em' }}
          >
            404: Logement non trouvé !??
          </Typography>
        </Paper>
      </div>
    );
  }
};

export default SiteDetailsPage;
